import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  Stack,
  Flex,
} from '@chakra-ui/react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const CTASection = () => {
  const location = useLocation();

  const handleContactClick = (e) => {
    if (location.pathname === '/contact') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <Box
      as="section"
      py={{ base: 10, md: 14 }}
      bg="#071326"
      position="relative"
      overflow="hidden"
    >
      <Container maxW="container.xl" px={{ base: 5, md: 8 }}>
        <Box
          bg="#0A1B34"
          border="1px solid"
          borderColor="rgba(255,255,255,0.10)"
          borderRadius="16px"
          px={{ base: 6, md: 10 }}
          py={{ base: 10, md: 14 }}
          position="relative"
          overflow="hidden"
        >
          <Flex
            direction="column"
            align="center"
            maxW="760px"
            mx="auto"
            textAlign="center"
            position="relative"
            zIndex={1}
          >
            <Box
              h="1px"
              w="80px"
              bg="linear-gradient(90deg, transparent 0%, #D4A85F 50%, transparent 100%)"
              mx="auto"
              mb={5}
            />

            <Heading
              as="h2"
              fontFamily="heading"
              fontWeight={500}
              fontSize={{ base: '2rem', sm: '2.4rem', md: '3rem' }}
              lineHeight={1.05}
              letterSpacing="0"
              color="#F5F7FA"
              mb={4}
            >
              Your first fractional property,{' '}
              <Box
                as="span"
                sx={{
                  background: 'linear-gradient(135deg, #D4A85F 0%, #E0B873 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                from $1,000
              </Box>
              .
            </Heading>

            <Text
              fontFamily="body"
              fontSize={{ base: 'md', md: 'lg' }}
              color="#9AA7B8"
              lineHeight={1.65}
              mb={8}
              maxW="560px"
            >
              Join 1,800+ investors building wealth through premium real estate.
              Sign up in minutes — no commitment required.
            </Text>

            <Stack
              direction="row"
              spacing={{ base: 3, sm: 4 }}
              justifyContent="center"
              align="center"
              w={{ base: 'full', sm: 'auto' }}
            >
              <Button
                as={RouterLink}
                to="/register"
                variant="primary"
                h="48px"
                px={{ base: 4, sm: 8 }}
                fontSize={{ base: 'xs', sm: 'sm' }}
                flex={{ base: 1, sm: '0 0 auto' }}
                minW={{ sm: '180px' }}
              >
                Create Account
              </Button>

              <Button
                as={RouterLink}
                to="/contact"
                variant="outline"
                h="48px"
                px={{ base: 4, sm: 8 }}
                fontSize={{ base: 'xs', sm: 'sm' }}
                flex={{ base: 1, sm: '0 0 auto' }}
                minW={{ sm: '180px' }}
                onClick={handleContactClick}
              >
                Contact Us
              </Button>
            </Stack>
          </Flex>
        </Box>
      </Container>
    </Box>
  );
};

export default CTASection;
